<section class="d-flex justify-content-center flex-column button-container">

  <div class="form-check mb-2">
    <input class="form-check-input" type="checkbox" [formControl]="includeNew" id="includeNew" />
    <label class="form-check-label" for="includeNew">Include new vehicles</label>
  </div>
  <div class="form-check mb-2">
    <input class="form-check-input" type="checkbox" [formControl]="includeUsedCert" id="includeUsedCert" />
    <label class="form-check-label" for="includeUsedCert">Include used and certified vehicles</label>
  </div>
  <div class="form-check mb-2">
    <input class="form-check-input" type="checkbox" [formControl]="filterByVin" id="filterByVin" />
    <label class="form-check-label" for="filterByVin">Only trigger imports for specific VIN</label>
  </div>

  <input class="form-control mb-2" *ngIf="filterByVin.value" [formControl]="vin" placeholder="VIN" type="text" />
  <button class="btn app-btn-outline-success mb-2" (click)="triggerResidualAutomation()" [disabled]="triggerButtonDisabled">Trigger residual automation</button>
</section>